import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { IRestrictedWord } from "./restrictedWords.types";

export const FETCH_RESTRICTED_WORDS_LIST_PROGRESS =
  "FETCH_RESTRICTED_WORDS_LIST_PROGRESS";
export const FETCH_RESTRICTED_WORDS_LIST_SUCCESS =
  "FETCH_RESTRICTED_WORDS_LIST_SUCCESS";
export const FETCH_RESTRICTED_WORDS_LIST_FAILED =
  "FETCH_RESTRICTED_WORDS_LIST_FAILED";

export const fetchRestrictedWordsListProgress = () =>
  action(FETCH_RESTRICTED_WORDS_LIST_PROGRESS);
export const fetchRestrictedWordsListSuccess = (
  data: IRestrictedWord[],
  totalRecords: number
) => action(FETCH_RESTRICTED_WORDS_LIST_SUCCESS, { data, totalRecords });
export const fetchRestrictedWordsListFailed = () =>
  action(FETCH_RESTRICTED_WORDS_LIST_FAILED);

export const fetchRestrictedWordsListAsync =
  (
    companyOutletUuid: string,
    pageNumber: number,
    itemPerPage: number,
    pageLimit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue?: IDatatableV2AdvancedSearchFilter,
    searchByWord?: string,
    restrictedWordsUuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(fetchRestrictedWordsListProgress());
    try {
      dispatch(saveLoaderProgress());
      let searchQuery = "";

      if (searchByWord) {
        searchQuery += `&word=${searchByWord}`;
      }

      if (restrictedWordsUuid) {
        searchQuery += `&restricted_words_uuid=${restrictedWordsUuid}`;
      }

      if (searchValue?.length ?? 0) {
        const advanceFilter = [...(searchValue || [])];
        searchQuery += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      searchQuery += `&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (status && status !== "-1") {
        searchQuery += `&status=${status}`;
      }

      const response = await api.get(
        `/general/get-restricted-word?company_outlet_uuid=${companyOutletUuid}&pageNo=${pageNumber}&pageLimit=${pageLimit}&itemPerPage=${itemPerPage}` +
          searchQuery
      );
      const data: IRestrictedWord[] = response.data.data || [];

      const totalRecords = response.data.totalRecords || 0;
      dispatch(fetchRestrictedWordsListSuccess(data, totalRecords));
    } catch (error) {
      dispatch(fetchRestrictedWordsListFailed());
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertRestrictedWord =
  (
    data: IRestrictedWord,
    onCallback?: (isSuccess: boolean, data?: IRestrictedWord) => void
  ) =>
  async (dispatch: any) => {
    try {
      dispatch(saveLoaderProgress());
      const response = await api.post("/general/upsert-restricted-word", data);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "success",
          message: data.restricted_words_uuid
            ? "Restricted word updated successfully"
            : "Restricted word created successfully",
          displayAs: "snackbar",
        })
      );
      onCallback?.(true, response.data);
      return response.data;
    } catch (error: any) {
      onCallback?.(false);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "error",
          message: error.response?.data?.message || "Failed to save restricted word",
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_RESTRICTED_WORDS_STATE = "CLEAR_RESTRICTED_WORDS_STATE";
export const clearRestrictedWordsState = () =>
  action(CLEAR_RESTRICTED_WORDS_STATE);
